import script from "./Box_item.vue?vue&type=script&setup=true&lang=js"
export * from "./Box_item.vue?vue&type=script&setup=true&lang=js"

import "./Box_item.vue?vue&type=style&index=0&id=567d48d3&lang=less"

export default script